(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multimedia-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('multimedia-gallery')) return;

    const formatTime = (s) => {
      if (!Number.isFinite(s) || s < 0) return '0:00';
      const m = Math.floor(s / 60);
      const sec = Math.floor(s % 60);
      return `${m}:${String(sec).padStart(2, '0')}`;
    };

    const pauseAllAudio = (except) => {
      document.querySelectorAll('multimedia-gallery audio').forEach((a) => {
        if (a !== except && !a.paused) a.pause();
      });
    };

    class MultimediaGallery extends HTMLElement {
      constructor() {
        super();
        this.tick = this.tick.bind(this);
      }

      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;

        this.stage = this.querySelector('[data-mg-stage]');
        this.slides = Array.from(this.querySelectorAll('[data-mg-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-mg-dot]'));
        this.prevBtn = this.querySelector('[data-mg-prev]');
        this.nextBtn = this.querySelector('[data-mg-next]');
        this.status = this.querySelector('[data-mg-status]');
        this.videoModal = this.querySelector('[data-mg-video-modal]');
        this.storyModal = this.querySelector('[data-mg-story-modal]');
        this.count = this.slides.length;
        this.loop = this.dataset.loop === 'true';
        this.storyDuration = (parseFloat(this.dataset.storyDuration) || 10) * 1000;
        this.labels = {
          play: this.dataset.labelPlay || 'Play',
          pause: this.dataset.labelPause || 'Pause',
          of: this.dataset.labelOf || '/',
        };
        this.index = 0;
        this.story = null;

        if (!this.count) return;

        this.initCarousel(signal);
        this.initCards(signal);
        this.initAudio(signal);
        this.initVideo(signal);
        this.initStories(signal);
        this.update(true);
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));

        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const slide = e.target && e.target.closest ? e.target.closest('[data-mg-slide]') : null;
            if (!slide || !this.contains(slide)) return;
            const i = this.slides.indexOf(slide);
            if (i > -1) this.goTo(i);
          },
          { signal }
        );
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.endStory();
        document.documentElement.classList.remove('mg-lock');
      }

      /* ================= Carousel ================= */
      initCarousel(signal) {
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1), { signal });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1), { signal });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i), { signal }));

        this.stage.addEventListener(
          'click',
          (e) => {
            if (this.suppressClick) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            const slide = e.target.closest('[data-mg-slide]');
            if (slide && !slide.classList.contains('is-active')) {
              e.preventDefault();
              e.stopPropagation();
              this.goTo(this.slides.indexOf(slide));
            }
          },
          { capture: true, signal }
        );

        this.stage.addEventListener(
          'pointerdown',
          (e) => {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            this.drag = { x: e.clientX, y: e.clientY };
          },
          { signal }
        );
        this.stage.addEventListener(
          'pointerup',
          (e) => {
            if (!this.drag) return;
            const dx = e.clientX - this.drag.x;
            const dy = e.clientY - this.drag.y;
            this.drag = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              this.suppressClick = true;
              setTimeout(() => (this.suppressClick = false), 350);
              this.go(dx < 0 ? 1 : -1);
            }
          },
          { signal }
        );
        this.stage.addEventListener('pointercancel', () => (this.drag = null), { signal });
        this.stage.addEventListener('dragstart', (e) => e.preventDefault(), { signal });

        this.addEventListener(
          'keydown',
          (e) => {
            if (e.target.closest('dialog') || e.target.closest('[data-mg-audio-bar]')) return;
            if (e.key === 'ArrowLeft') {
              e.preventDefault();
              this.go(-1);
            } else if (e.key === 'ArrowRight') {
              e.preventDefault();
              this.go(1);
            }
          },
          { signal }
        );
      }

      go(dir) {
        let i = this.index + dir;
        if (this.loop) i = (i + this.count) % this.count;
        else i = Math.max(0, Math.min(this.count - 1, i));
        this.goTo(i);
      }

      goTo(i) {
        if (i === this.index || i < 0 || i >= this.count) return;
        this.index = i;
        this.update();
      }

      offsetFor(i) {
        let o = i - this.index;
        if (this.loop && this.count > 2) {
          const half = this.count / 2;
          if (o > half) o -= this.count;
          if (o < -half) o += this.count;
        }
        return o;
      }

      update(initial = false) {
        this.slides.forEach((slide, i) => {
          const o = this.offsetFor(i);
          const abs = Math.abs(o);
          const active = o === 0;
          const jumped = !initial && slide._mgOffset !== undefined && Math.abs(o - slide._mgOffset) > 1;

          if (jumped) slide.classList.add('is-jumping');
          slide.style.setProperty('--o', o);
          slide.style.setProperty('--abs', Math.min(abs, 3));
          slide.style.zIndex = String(10 - Math.min(abs, 3));
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-near', abs === 1);
          slide.classList.toggle('is-far', abs === 2);
          slide.classList.toggle('is-hidden', abs > 2);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('[data-mg-focusable]').forEach((el) => (el.tabIndex = active ? 0 : -1));

          if (!active) {
            const card = slide.querySelector('[data-mg-card].is-flipped');
            if (card) this.setFlipped(card, false);
            const audio = slide.querySelector('audio');
            if (audio && !audio.paused) audio.pause();
          }

          if (jumped) {
            void slide.offsetWidth;
            slide.classList.remove('is-jumping');
          }
          slide._mgOffset = o;
        });

        this.dots.forEach((dot, i) => {
          const on = i === this.index;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
          if (this.nextBtn) this.nextBtn.disabled = this.index === this.count - 1;
        }

        if (!initial && this.status) this.status.textContent = `${this.index + 1} ${this.labels.of} ${this.count}`;
      }

      /* ================= Cards ================= */
      initCards(signal) {
        this.querySelectorAll('[data-mg-card]').forEach((card) => {
          const toggle = () => this.setFlipped(card, !card.classList.contains('is-flipped'));
          card.addEventListener('click', toggle, { signal });
          card.addEventListener(
            'keydown',
            (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
              }
            },
            { signal }
          );
        });
      }

      setFlipped(card, flipped) {
        card.classList.toggle('is-flipped', flipped);
        card.setAttribute('aria-pressed', String(flipped));
        const front = card.querySelector('[data-mg-face="front"]');
        const back = card.querySelector('[data-mg-face="back"]');
        if (front) front.setAttribute('aria-hidden', String(flipped));
        if (back) back.setAttribute('aria-hidden', String(!flipped));
      }

      /* ================= Audio ================= */
      initAudio(signal) {
        this.querySelectorAll('[data-mg-audio]').forEach((tile) => {
          const audio = tile.querySelector('audio');
          const btn = tile.querySelector('[data-mg-audio-toggle]');
          const bar = tile.querySelector('[data-mg-audio-bar]');
          const fill = tile.querySelector('[data-mg-audio-fill]');
          const time = tile.querySelector('[data-mg-audio-time]');
          if (!audio) return;

          const render = () => {
            const d = audio.duration;
            const pct = d ? (audio.currentTime / d) * 100 : 0;
            fill.style.width = `${pct}%`;
            bar.setAttribute('aria-valuenow', String(Math.round(pct)));
            const fresh = audio.paused && audio.currentTime === 0;
            time.textContent = fresh ? formatTime(d) : formatTime(audio.currentTime);
            tile.classList.toggle('is-playing', !audio.paused);
            btn.setAttribute('aria-label', audio.paused ? this.labels.play : this.labels.pause);
          };

          ['loadedmetadata', 'durationchange', 'timeupdate', 'play', 'pause'].forEach((ev) =>
            audio.addEventListener(ev, render, { signal })
          );
          audio.addEventListener(
            'ended',
            () => {
              audio.currentTime = 0;
              render();
            },
            { signal }
          );

          const toggle = () => {
            if (audio.paused) {
              pauseAllAudio(audio);
              audio.play().catch(() => {});
            } else {
              audio.pause();
            }
          };
          tile.addEventListener('click', toggle, { signal });

          let seeking = false;
          const seekTo = (clientX) => {
            const r = bar.getBoundingClientRect();
            const p = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
            if (audio.duration) audio.currentTime = p * audio.duration;
            render();
          };
          bar.addEventListener(
            'pointerdown',
            (e) => {
              e.stopPropagation();
              seeking = true;
              bar.setPointerCapture(e.pointerId);
              seekTo(e.clientX);
            },
            { signal }
          );
          bar.addEventListener('pointermove', (e) => seeking && seekTo(e.clientX), { signal });
          bar.addEventListener('pointerup', () => (seeking = false), { signal });
          bar.addEventListener('pointercancel', () => (seeking = false), { signal });
          bar.addEventListener('click', (e) => e.stopPropagation(), { signal });
          bar.addEventListener(
            'keydown',
            (e) => {
              if (!audio.duration) return;
              if (e.key === 'ArrowRight') audio.currentTime = Math.min(audio.duration, audio.currentTime + 5);
              else if (e.key === 'ArrowLeft') audio.currentTime = Math.max(0, audio.currentTime - 5);
              else return;
              e.preventDefault();
              e.stopPropagation();
              render();
            },
            { signal }
          );

          render();
        });
      }

      /* ================= Video ================= */
      initVideo(signal) {
        const modal = this.videoModal;
        if (!modal) return;
        const body = modal.querySelector('[data-mg-modal-body]');

        this.querySelectorAll('[data-mg-video]').forEach((tile) => {
          tile.addEventListener(
            'click',
            () => {
              const tpl = tile.querySelector('template[data-mg-video-template]');
              if (!tpl) return;
              pauseAllAudio();
              body.replaceChildren(tpl.content.cloneNode(true));
              document.documentElement.classList.add('mg-lock');
              modal.showModal();
              const video = body.querySelector('video');
              if (video) {
                const p = video.play();
                if (p && p.catch) {
                  p.catch(() => {
                    video.muted = true;
                    video.play().catch(() => {});
                  });
                }
              }
            },
            { signal }
          );
        });

        modal.querySelector('[data-mg-modal-close]').addEventListener('click', () => modal.close(), { signal });
        modal.addEventListener('click', (e) => e.target === modal && modal.close(), { signal });
        modal.addEventListener(
          'close',
          () => {
            body.replaceChildren();
            document.documentElement.classList.remove('mg-lock');
          },
          { signal }
        );
      }

      /* ================= Stories ================= */
      initStories(signal) {
        const modal = this.storyModal;
        if (!modal) return;
        this.storyStage = modal.querySelector('[data-mg-story-stage]');
        this.storyTarget = modal.querySelector('[data-mg-story-target]');
        this.storyBars = modal.querySelector('[data-mg-story-bars]');

        this.querySelectorAll('[data-mg-story]').forEach((tile) =>
          tile.addEventListener('click', () => this.openStory(tile), { signal })
        );

        modal.querySelector('[data-mg-story-close]').addEventListener('click', () => this.endStory(), { signal });
        modal.querySelector('[data-mg-story-prev]').addEventListener('click', () => this.storyPrev(), { signal });
        modal.querySelector('[data-mg-story-next]').addEventListener('click', () => this.storyNext(), { signal });
        modal.addEventListener('close', () => this.endStory(), { signal });
        // Clicking the see-through overlay around the story closes it
        modal.addEventListener('click', (e) => e.target === modal && this.endStory(), { signal });

        modal.addEventListener(
          'keydown',
          (e) => {
            if (!this.story) return;
            if (e.key === 'ArrowRight') {
              e.preventDefault();
              this.storyNext();
            } else if (e.key === 'ArrowLeft') {
              e.preventDefault();
              this.storyPrev();
            } else if (e.key === ' ' && !e.target.closest('button')) {
              e.preventDefault();
              this.story.manualPause = !this.story.manualPause;
              this.syncStoryPause();
            }
          },
          { signal }
        );

        const stage = this.storyStage;
        const cancelPress = () => {
          if (!this.story || !this.story.press) return;
          this.story.press = null;
          this.story.holding = false;
          this.syncStoryPause();
        };

        stage.addEventListener(
          'pointerdown',
          (e) => {
            if (!this.story || e.target.closest('button')) return;
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            this.story.press = { x: e.clientX, y: e.clientY, t: performance.now() };
            this.story.holding = true;
            this.syncStoryPause();
          },
          { signal }
        );
        stage.addEventListener('pointerup', (e) => this.onStoryRelease(e), { signal });
        stage.addEventListener('pointercancel', cancelPress, { signal });
        stage.addEventListener('pointerleave', cancelPress, { signal });
        stage.addEventListener('contextmenu', (e) => e.preventDefault(), { signal });
      }

      openStory(tile) {
        const tpl = tile.querySelector('template[data-mg-story-frames]');
        if (!tpl || !this.storyModal) return;
        this.storyTarget.replaceChildren(tpl.content.cloneNode(true));
        const frames = Array.from(this.storyTarget.querySelectorAll('[data-mg-story-frame]'));
        if (!frames.length) return;

        const bars = frames.map(() => {
          const bar = document.createElement('span');
          bar.className = 'mg-story-viewer__bar';
          const fill = document.createElement('span');
          fill.className = 'mg-story-viewer__fill';
          bar.append(fill);
          return bar;
        });
        this.storyBars.replaceChildren(...bars);

        this.story = {
          frames,
          fills: bars.map((b) => b.firstChild),
          i: 0,
          elapsed: 0,
          last: null,
          holding: false,
          manualPause: false,
          paused: false,
          press: null,
          raf: 0,
        };

        pauseAllAudio();
        document.documentElement.classList.add('mg-lock');
        this.storyModal.showModal();
        this.showStoryFrame(0);
        this.story.raf = requestAnimationFrame(this.tick);
      }

      showStoryFrame(i) {
        const s = this.story;
        if (!s) return;
        s.i = i;
        s.elapsed = 0;
        s.frames.forEach((f, idx) => {
          f.classList.toggle('is-active', idx === i);
          f.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
        });
        s.fills.forEach((f, idx) => (f.style.transform = `scaleX(${idx < i ? 1 : 0})`));
      }

      storyNext() {
        const s = this.story;
        if (!s) return;
        if (s.i < s.frames.length - 1) this.showStoryFrame(s.i + 1);
        else this.endStory();
      }

      storyPrev() {
        const s = this.story;
        if (!s) return;
        this.showStoryFrame(Math.max(0, s.i - 1));
      }

      syncStoryPause() {
        const s = this.story;
        if (!s) return;
        s.paused = s.holding || s.manualPause;
        this.storyModal.classList.toggle('is-holding', s.holding);
      }

      onStoryRelease(e) {
        const s = this.story;
        if (!s || !s.press) return;
        const { x, y, t } = s.press;
        s.press = null;
        s.holding = false;
        const dx = e.clientX - x;
        const dy = e.clientY - y;
        const held = performance.now() - t;

        if (dy > 80 && Math.abs(dy) > Math.abs(dx)) {
          this.endStory();
          return;
        }
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          dx < 0 ? this.storyNext() : this.storyPrev();
        } else if (held < 250) {
          const r = this.storyStage.getBoundingClientRect();
          e.clientX - r.left < r.width * 0.3 ? this.storyPrev() : this.storyNext();
        }
        this.syncStoryPause();
      }

      tick(now) {
        const s = this.story;
        if (!s) return;
        const dt = s.last === null ? 0 : Math.min(now - s.last, 100);
        s.last = now;
        if (!s.paused) {
          s.elapsed += dt;
          const p = Math.min(s.elapsed / this.storyDuration, 1);
          s.fills[s.i].style.transform = `scaleX(${p})`;
          if (p >= 1) {
            this.storyNext();
            if (!this.story) return;
          }
        }
        s.raf = requestAnimationFrame(this.tick);
      }

      endStory() {
        if (this.story) {
          cancelAnimationFrame(this.story.raf);
          this.story = null;
        }
        if (this.storyModal) {
          this.storyModal.classList.remove('is-holding');
          if (this.storyModal.open) this.storyModal.close();
        }
        if (this.storyTarget) this.storyTarget.replaceChildren();
        if (this.storyBars) this.storyBars.replaceChildren();
        if (!this.videoModal || !this.videoModal.open) document.documentElement.classList.remove('mg-lock');
      }
    }

    customElements.define('multimedia-gallery', MultimediaGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
